var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!_vm.noLoading)?_c('app-loading',{attrs:{"modal":!_vm.standalone}}):_vm._e(),(_vm.appLoaded)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }